<div
  class="sidenav"
  id="sidenav-hover"
  (mouseenter)="onHover($event)"
  (mouseleave)="onHover($event)">
  <nav>
    <!-- @if (!isCollapse) { -->
    <div class="sidenav-header">
      <a
        routerLink="/dashboard"
        (mousedown)="middleClickHandle('/dashboard', $event)"
        class="brand"
        tabindex="-1">
        <img src="/images/core/orion-brand.svg" alt="Logo" />
        <span>
          Orion
          <span class="environment">{{ env2() }}</span>
        </span>
      </a>
    </div>
    <hr class="horizontal light" />
    <!-- } -->

    <div class="sidenav-tree">
      <mat-tree #tree [dataSource]="dataSource()" [childrenAccessor]="childrenAccessor">
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          (click)="onToggle(tree.isExpanded(node))"
          [attr.data-testid]="'menu-' + node.title"
          matTreeNodeToggle>
          @if (node.visible !== false) {
            @switch (node.type) {
              @case (0) {
                <span class="material-icons">{{ node.icon ? node.icon : 'inventory_2' }}</span>
                <span routerLinkActive="router-link-active" class="description">
                  {{ node.name }}
                </span>
                <button mat-icon-button [attr.aria-label]="'Toggle ' + node.name">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{ tree.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                  </mat-icon>
                </button>
              }
            }
          }
        </mat-tree-node>

        <mat-tree-node
          *matTreeNodeDef="let node"
          (click)="onChildClick(node)"
          [id]="'child-' + node.index"
          [attr.data-testid]="'menu-' + node.title">
          @if (node.visible !== false) {
            @switch (node.type) {
              @case (0) {
                <span>{{ node.icon }}</span>
                <span [id]="'childMenu-' + node.index" class="description">{{ node.name }}</span>
              }
            }
          }
        </mat-tree-node>
      </mat-tree>
    </div>
    <hr class="horizontal light" />
    @if (versionService.version(); as version) {
      <span class="sidenav-version">Ver.:{{ version }}</span>
    }
  </nav>
</div>
